<template>
  <RfDialog
    ref="dialogRef"
    :title="title"
    width="580"
    confirmText="Save"
    :disabled="!localName.trim()"
    @confirm="handleConfirm"
    @open="emit('open')"
    @close="emit('close')"
  >
    <div class="flex flex-col gap-4 pt-2">
      <RfInput
        v-model="localName"
        title="Name"
        placeholder="Enter a name"
        requiredTitle
        variant="outlined"
        autoWidth
      />
      <RfInput
        v-model="localDesc"
        title="Description"
        placeholder="Enter a description"
        variant="outlined"
        autoWidth
      />
    </div>
  </RfDialog>
</template>

<script setup>
import { ref, useTemplateRef } from "vue";
import RfDialog from "@/components/modals/RfDialog.vue";
import RfInput from "@/components/inputs/RfInput.vue";

const emit = defineEmits(["confirm", "open", "close"]);
defineProps({
  title: { type: String, default: "Edit" },
});

const dialogRef = useTemplateRef("dialogRef");
const localName = ref("");
const localDesc = ref("");

/**
 * Open the dialog pre-filled with the given name and description.
 *
 * @param {{ name?: string, description?: string }} [data={}] - Initial field values.
 */
const open = ({ name, description } = {}) => {
  localName.value = name ?? "";
  localDesc.value = description ?? "";
  dialogRef.value?.open();
};

const close = () => dialogRef.value?.close();

const handleConfirm = () => {
  emit("confirm", { name: localName.value.trim(), description: localDesc.value.trim() });
};

defineExpose({ open, close });
</script>
